import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ASSETINSPECTIONCATEGORY,
  DELETE_ASSETINSPECTIONCATEGORY,
  UPDATE_ASSETINSPECTIONCATEGORY,
  ADD_NEW_ASSETINSPECTIONCATEGORY,
} from "./actionType";

import {
  getAssetInspectionCategorySuccess,
  getAssetInspectionCategoryFail,
  deleteAssetInspectionCategorySuccess,
  deleteAssetInspectionCategoryFail,
  updateAssetInspectionCategorySuccess,
  updateAssetInspectionCategoryFail,
  addAssetInspectionCategorySuccess,
  addAssetInspectionCategoryFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAssetInspectionCategoryApi,
  getAssetInspectionCategoryApi,
  updateAssetInspectionCategoryApi,
  deleteAssetInspectionCategoryApi,
  addNewAssetInspectionCategoryApi
} from "../../helpers/backend_helper";

function* getAssetInspectionCategory({ payload: assetInspectionCategory }) {
  try {
    const response = yield call(getAssetInspectionCategoryApi, assetInspectionCategory);
    yield put(getAssetInspectionCategorySuccess(GET_ASSETINSPECTIONCATEGORY, response.data));
  } catch (error) {
    yield put(getAssetInspectionCategoryFail(GET_ASSETINSPECTIONCATEGORY, error));
  }
}

function* onUpdateAssetInspectionCategory({ payload: assetInspectionCategory }) {
  try {
    if (assetInspectionCategory.setApprove) {
      const response = yield call(approveAssetInspectionCategoryApi, assetInspectionCategory);
      yield put(updateAssetInspectionCategorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAssetInspectionCategoryApi, assetInspectionCategory);
      yield put(updateAssetInspectionCategorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAssetInspectionCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAssetInspectionCategory({ payload: assetInspectionCategory }) {
  try {
    const response = yield call(deleteAssetInspectionCategoryApi, assetInspectionCategory);
    yield put(deleteAssetInspectionCategorySuccess({ assetInspectionCategory, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAssetInspectionCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAssetInspectionCategory({ payload: assetInspectionCategory }) {
  try {
    const response = yield call(addNewAssetInspectionCategoryApi, assetInspectionCategory);
    yield put(addAssetInspectionCategorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAssetInspectionCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetAssetInspectionCategory() {
  yield takeEvery(GET_ASSETINSPECTIONCATEGORY, getAssetInspectionCategory);
}

export function* watchUpdateAssetInspectionCategory() {
  yield takeEvery(UPDATE_ASSETINSPECTIONCATEGORY, onUpdateAssetInspectionCategory);
}

export function* watchDeleteAssetInspectionCategory() {
  yield takeEvery(DELETE_ASSETINSPECTIONCATEGORY, onDeleteAssetInspectionCategory);
}

export function* watchAddNewAssetInspectionCategory() {
  yield takeEvery(ADD_NEW_ASSETINSPECTIONCATEGORY, onAddNewAssetInspectionCategory);
}

function* assetInspectionCategorySaga() {
  yield all([
    fork(watchGetAssetInspectionCategory),
    fork(watchDeleteAssetInspectionCategory),
    fork(watchUpdateAssetInspectionCategory),
    fork(watchAddNewAssetInspectionCategory)
  ]);
}

export default assetInspectionCategorySaga;
